// extracted by mini-css-extract-plugin
module.exports = {"icon":"event-status_icon__2E9wg","green":"event-status_green__DM6sG","blue":"event-status_blue__FiZVN","yellow":"event-status_yellow__3B2co"};